export const environment = (() => {
  switch (process.env.EXPO_PUBLIC_ENVIRONMENT) {
    case 'staging':
    case 'production':
      return process.env.EXPO_PUBLIC_ENVIRONMENT
    default:
      return 'local'
  }
})()

export const isProduction = environment === 'production'

export const isE2E = process.env.EXPO_PUBLIC_IS_E2E === 'true'
